module.exports = __webpack_public_path__ + "img/h5img32.d3805e89.png";